<template>
	<div class="content-wrapper">
		<div class="sf-flex-column">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-container ref="searchContainer" @Refresh="Refresh" :scrId="scrId"></search-container>
				</sf-card>
			</div>
			<div class="sf-col sf-col-15">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<table-container ref="tableContainer" @popupOpen="popupOpen" :scrId="scrId"></table-container>
				</sf-card>
			</div>
			<div class="sf-col sf-col-5">
				<!-- <table-master-info :scrId="scrId" @OpenPopup="OpenPopup"></table-master-info> -->
				<table-master-info :scrId="scrId"></table-master-info>
			</div>
			<div class="sf-col sf-col-5">
				<!--업체정보팝업버튼 테이블-->
				<table-company ref="tableCompany" :scrId="scrId" :sendParam="sendParam" @OpenPopup="OpenPopup"></table-company>
			</div>
			<div class="sf-col sf-col-5">
				<!--공통코드팝업버튼 테이블-->
				<table-comm-code ref="tableCompany" :scrId="scrId" :sendParam="sendParam" @OpenPopupCommCode="OpenPopupCommCode"></table-comm-code>
			</div>
			<!-- <div class="my-2 sf-col sf-col-20">
				<el-row :gutter="20" class="p-0 h-100">
					<el-col :span="8" class="h-100">
						<table-container @Refresh="Refresh" :scrId="scrId"></table-container>
					</el-col>
					<el-col :span="8" class="h-100">
						<table-container ref="tableContainer" @popupOpen="popupOpen" @Refresh="Refresh" :scrId="scrId"></table-container>
					</el-col>
					<el-col :span="8" class="h-100">
						<table-container @popupOpen="popupOpen" @Refresh="Refresh" :scrId="scrId"></table-container>
					</el-col>
				</el-row>
			</div> -->
		</div>
		<popup-view ref="popupView" @popupOpen="popupOpen" :scrId="scrId"></popup-view>
		<user-popup-view ref="userPopupView" @SendData="sendData" @Refresh="Refresh" :scrId="scrId" />
		<!--업체정보팝업-->
		<comp-popup ref="compPopup" @SendData="sendData" @Refresh="Refresh" :scrId="scrId"></comp-popup>
		<!--공통코드팝업-->
		<com-cd-popup ref="comCdPopup" @SendData="sendData" @Refresh="Refresh" :scrId="scrId"></com-cd-popup>
	</div>
</template>

<script>
import ComCdPopup from '../../comm/commpopup/ComCdPopup/ComCdPopup.vue';
import CompPopup from '../../comm/commpopup/CompPopup/CompPopup.vue';
import UserPopupView from '../../comm/commpopup/UserPopup/UserPopupView.vue';
import PopupView from './Popup/PopupView.vue';
import SearchContainer from './Search/SearchContainer.vue';
import TableContainer from './Table/TableContainer.vue';
import TableMasterInfo from './Table/TableMasterInfo.vue';
import TableCompany from './Table/TableCompany.vue';
import TableCommCode from './Table/TableCommCode.vue';
// import Variable from './Variable/Variable.vue';
// import Table2Container from './Table/Table2Container.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			sendParam: {},
			faivorite: true,
			screen: {}
		};
	},
	components: {
		SearchContainer,
		TableContainer,
		PopupView,
		TableMasterInfo,
		UserPopupView,
		CompPopup,
		TableCompany,
		TableCommCode,
		ComCdPopup
	},
	methods: {
		popupOpen(param) {
			this.$refs.popupView.open(param);
		},
		Refresh(currentPage = 1, pageUnit = 30) {
			//$refs 는 컴포넌트에 ref로 정의한 이름으로 접근할때 사용한다.
			this.$refs.searchContainer.searchList(currentPage, pageUnit);
			this.$refs.UserPopupView.searchList(currentPage, pageUnit);
			this.$refs.compPopup.searchList(currentPage, pageUnit);
		},
		OpenPopup(param) {
			//console.log('ContentView 에서의 cpnyCd 값 ::::: ', param.cpnyCd);
			// if (param.cpnyCd == null || param.cpnyCd == '') {
			// 	console.log('초기값');
			// } else {
			// 	console.log('검색값존재');
			// 	param.cpnyCd = '';
			// 	console.log('리셋됫니?', param.cpnyCd);
			// }
			this.$refs.compPopup.open(param); //.open(param);
		},
		sendData(param) {
			//alert('최종 팝업화면에서 가지고온 데이터 ::::: cpnyCd 는 ' + param.cpnyCd + ', cpnyNm은 ' + param.cpnyNm);
			this.sendParam = param;
		},
		OpenPopupCommCode(param) {
			//console.log('ContentView 에서의 commmCode 값 ::::: ', param);

			this.$refs.comCdPopup.open(param); //.open(param);
		}
	}
};
</script>

<style></style>
